import {DataInfoItemVo} from "src/app/core/vo/data-info-item.vo";
import {ListItemVO} from "src/app/core/vo/list-item.vo";

export class SourceItemVo {
  type: string;
  dataInfo: DataInfoItemVo = new DataInfoItemVo();
  options: Array<ListItemVO> = [];
  params: Array<any> =[];
}
